import { formatDateDisplay } from '../constants/hrmsAttendanceDetails.constants'

interface RegularizationEmployeeStripProps {
  name: string
  designation: string
  employeeId: string
  department: string
  selectedDate: string
}

function getInitials(name: string): string {
  const parts = name.trim().split(' ')
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

export function RegularizationEmployeeStrip({
  name,
  designation,
  employeeId,
  department,
  selectedDate,
}: RegularizationEmployeeStripProps) {
  return (
    <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3 min-w-0">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 rounded-full bg-[#146971] text-white flex items-center justify-center font-bold text-xs shrink-0">
          {getInitials(name)}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-bold text-slate-900 truncate">{name}</div>
          <div className="text-xs text-slate-500 mt-0.5 flex items-center gap-1.5 flex-wrap">
            <span className="font-bold text-[#146971]">{employeeId}</span>
            <span className="text-slate-300">•</span>
            <span className="font-medium text-slate-500">{department}</span>
            <span className="text-slate-300">•</span>
            <span className="font-medium text-slate-500">{designation}</span>
          </div>
        </div>
      </div>

      <div className="sm:text-right shrink-0">
        <div className="text-[10px] font-bold uppercase text-slate-400 tracking-wider">
          ATTENDANCE DATE
        </div>
        <div className="text-xs font-bold text-slate-800 mt-0.5">
          {formatDateDisplay(selectedDate)}
        </div>
      </div>
    </div>
  )
}
